const FALLBACK_ICON = 'fas fa-bolt';

export const quickActionIcon = (icon?: string): string =>
  icon?.trim() || FALLBACK_ICON;
